import { css } from '@emotion/react'

export const minimizedTabStyle = (variableColor: string) =>
  css({
    display: 'flex',
    flexDirection: 'column',
    color: 'white',
    width: '100%',
    position: 'relative',
    '.display-segment': {
      width: 'fit-content',
      padding: '5px 15px',
      marginTop: 15,
      marginRight: 7,
      marginLeft: 7,
      cursor: 'pointer',
      borderRadius: 5,
      ':hover': {
        backgroundColor: 'rgba(0,0,0,0.2)',
      },
      '.image-holder': {
        display: 'flex',
        justifyContent: 'center',
        width: 20,
        height: 20,
      },
    },
    '.tab-dropdown': {
      paddingBlock: 10,
      transition: 'all 0.3s ease',
      zIndex: 1000,
      position: 'absolute',
      top: '50%',
      left: 'calc(100% + 1px)',
      width: '250px',
      height: 'fit-content',
      backgroundColor: variableColor,
      display: 'flex',
      flexDirection: 'column',
      fontWeight: 300,
      '.header': {
        fontWeight: 600,
        fontSize: '12px',
        marginLeft: 10,
        marginRight: 10,
      },
    },
    '.tab-dropdown-1': {
      display: 'flex',
      flexDirection: 'column',
    },
    '.tab-dropdown-2': {
      display: 'flex',
      flexDirection: 'column',
    },
    '.segment-rounded': {
      paddingRight: 20,
      minWidth: 140,
      ':hover': {
        backgroundColor: 'rgba(0,0,0,0.2)',
      },
    },
    '.display-segment-2': {
      paddingLeft: 25,
    },
    '.display-segment-3': {
      paddingLeft: 40,
    },
    '.display-segment-4': {
      paddingLeft: 35,
    },
  })

export const tabBaseStyle = () =>
  css({
    display: 'flex',
    flexDirection: 'column',
    color: 'white',
    '.segment-rounded': {
      borderTopRightRadius: 10,
      borderBottomRightRadius: 10,
      marginRight: 2,
      ':hover': {
        backgroundColor: 'rgba(0,0,0,0.2)',
      },
      '.image-holder': {
        display: 'flex',
        justifyContent: 'center',
        width: 20,
        height: 20,
        margin: 6,
      },
    },
    '.display-segment': {
      display: 'flex',
      cursor: 'pointer',
      paddingInline: 10,
      '.text-holder': {
        minWidth: 140,
        margin: 6,
      },
    },
    '.tab-dropdown': {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      '.tab-dropdown-1': {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        '.display-segment-2': {
          paddingLeft: 50,
          display: 'flex',
          cursor: 'pointer',
          '.display-segment-2-content': {
            display: 'flex',
            alignItems: 'center',
          },
          '.text-holder': {
            minWidth: 120,
            margin: 6,
          },
        },
        '.display-segment-2-icon': {
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingRight: 10,
        },
        '.tab-dropdown-2': {
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          '.display-segment-3': {
            paddingLeft: 62,
            paddingRight: 10,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            cursor: 'pointer',
            '.text-holder': {
              minWidth: 120,
              margin: 6,
            },
          },
          '.tab-dropdown-3': {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            '.display-segment-4': {
              paddingLeft: 85,
              display: 'flex',
              cursor: 'pointer',
              '.text-holder': {
                minWidth: 120,
                margin: 6,
              },
            },
          },
        },
      },
    },
  })

export const minimizedPopupStyle = (variableColor: string) =>
  css({
    position: 'fixed',
    zIndex: 9999,
    backgroundColor: variableColor,
    width: 250,
    paddingBlock: 10,
    display: 'flex',
    flexDirection: 'column',
    fontWeight: 300,
    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
    color: 'white',
    '.header': {
      fontWeight: 600,
      fontSize: '12px',
      marginLeft: 10,
      marginRight: 10,
      marginBottom: 8,
    },
    '.text-holder': {
      cursor: 'pointer',
    },
    '.display-segment': {
      '.text-holder': {
        minWidth: 140,
      },
    },
    '.display-segment-2': {
      paddingLeft: 25,
      '.text-holder': {
        minWidth: 120,
      },
    },
    '.display-segment-3': {
      paddingLeft: 40,
      '.text-holder': {
        minWidth: 120,
      },
    },
    '.display-segment-4': {
      paddingLeft: 35,
      '.text-holder': {
        minWidth: 120,
      },
    },
    '.segment-rounded': {
      '&:hover': {
        backgroundColor: 'rgba(0,0,0,0.2)',
      },
    },
  })
